import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { Dialog, Grid } from '@material-ui/core';

import { Button } from 'core/components/button';
import { Label } from 'core/components/label';
import { NotificationCard } from 'core/components/notification-card';
import pendingIcon from 'core/assets/svg/pending.svg';
import infoIcon from 'core/assets/svg/info-icon-dark.svg';
import { brandConstants } from 'brand-config';

import useStyles from './submitted-for-approval-modal.styles';

const SubmittedForApprovalModal = ({ open, onClose }) => {
  const classes = useStyles();

  return (
    <Dialog open={open} classes={{ paper: classes.coveragesInfo }}>
      <img src={pendingIcon} className={classes.icon} alt="Paper with two arrows forming a circle" />
      <Label type="h1">Policy changes awaiting {brandConstants.SHORT_NAME} approval.</Label>
      <div className={classes.content}>
        <Label className={classes.contentLabel} type="body1">
          Thank you for submitting your requests. We will let you know when the changes are approved, or if additional
          details are required.
        </Label>
      </div>
      <NotificationCard
        type="secondary"
        icon={infoIcon}
        iconSize="icon16"
        className={classes.preventDelaysCard}
        iconClassName={classes.preventDelaysCardIcon}
      >
        <div>
          <strong>Prevent resubmission delays</strong>
          <p>
            If you make additional changes to this policy before your changes are approved, you’ll need to submit your
            changes again for approval.
          </p>
        </div>
      </NotificationCard>
      <Grid container justifyContent="flex-end">
        <Button className={classes.button} variant="contained" color="primary" onClick={onClose}>
          Got it
        </Button>
      </Grid>
    </Dialog>
  );
};

SubmittedForApprovalModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default observer(SubmittedForApprovalModal);
